import {Component, Inject, OnInit} from "@angular/core";
import {NotifyResellerDTO} from "../../../persistence/dto/NotifyResellerDTO";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

@Component({
  selector: 'kt-dialog-notify-reseller',
  templateUrl: './dialog-notify-reseller.component.html',
  styleUrls: ['./dialog-notify-reseller.component.scss']
})
export class DialogNotifyResellerComponent implements OnInit {

  public constructor(@Inject(MAT_DIALOG_DATA) public data : NotifyResellerData,
              public dialogRef: MatDialogRef<DialogNotifyResellerComponent>) { }

    ngOnInit(): void {
      this.data.resellers = this.data.resellers.sort((r1, r2) => r2.price - r1.price)
    }

    public ok(): void {
      this.dialogRef.close("ok");

    }

    public onNoClick(): void {
        this.dialogRef.close();
    }



}

export class NotifyResellerData{
    resellers: NotifyResellerDTO[];
    showRedirect: boolean;
}
